import {LoadAfterConfirmationEvents} from "./loadAfterConfirmation";
import {Load} from "../../common/load";
import {resolve} from "../../container";
import {UnLitElement} from "../../common/elements";
import {customElement} from "lit/decorators.js";

@customElement("eop-flipping-book")
export class EopFlippingBook extends UnLitElement {
    private confirmationAbortController: AbortController;

    public constructor(
        private loadAfterConfirmationEvents: LoadAfterConfirmationEvents = resolve(LoadAfterConfirmationEvents),
        private load: Load = resolve(Load)
    ) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();
        const id = this.getAttribute("fbo-id");

        this.confirmationAbortController = this.loadAfterConfirmationEvents.onConfirmation("flippingbook", () => {
            return this.load.script(`https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=${id}`);
        });
    }

    public disconnectedCallback(): void {
        if (this.confirmationAbortController) {
            this.confirmationAbortController.abort();
        }

        super.disconnectedCallback();
    }
}